<template>
    <div class="container margin-top-20">
        <div class="row">
            <div class="col-md-6">
                <div @click="handleCreateExcersiceQuestionBank" class="menu-item display-flex">
                    <img class="icon-open-book" src="@/assets/img/open-book.png" />
                    <div class="tile-menu">
                        Tạo đề từ ngân hàng câu hỏi
                    </div>
                </div>

            </div>
            <div class="col-md-6">
                <div @click="handleCreateExcersiceExamBank" class="menu-item display-flex">
                    <img class="icon-open-book" src="@/assets/img/open-book.png" />
                    <div class="tile-menu">
                        Sử dụng đề từ ngân hàng đề thi
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <input type="file" hidden name="file" id="fileInputUpload" class="hidden-input"
                    @change="onChangeUploadFile" ref="file" accept=".docx,.doc" />
                <div @click="handleOnUploadFileDoc" class="menu-item display-flex">
                    <img class="icon-open-book" src="@/assets/img/open-book.png" />
                    <div class="tile-menu">
                        Tạo đề từ file Word
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div @click="handleCreateExcerciseByPdf" class="menu-item display-flex">
                    <img class="icon-open-book" src="@/assets/img/open-book.png" />
                    <div class="tile-menu">
                        Tạo đề từ file PDF
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="item-download" @click="downLoadTemplate">
                    <strong>Tải xuống file word mẫu</strong>
                </div>

            </div>
        </div>
        <div class="guideline row">
            <div class="col-md-12 col-lg-12">
                <div @click="handleViewHelpQuestionBank" class="item-instruct">
                    Hướng dẫn tạo đề từ ngân hàng câu hỏi
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div @click="handleViewHelpBank" class="item-instruct">
                    Hướng dẫn tạo đề từ ngân hàng đề
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div @click="handleViewHelpWord" class="item-instruct">
                    Hướng dẫn tạo đề file word
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div @click="handleViewHelpPdf" class="item-instruct">
                    Hướng dẫn tạo đề từ file pdf
                </div>
            </div>
        </div>
        <ModalCreateQuestionBank @closeModal="closeModalCreateQuestionBank" v-if="isOpenModalCreateQuestionBank"
            @handleDone="handleDoneChooseQuestion" />
        <ModalComfirmQuestionBank :typeUpload="typeUpload" :listDataQuestion="listDataQuestion"
            v-if="isOpenModalShowConfirmQuestionbank" @closeModal="closeModalConfirm"
            @handleDone="handleDoneQuestionbank" />

        <ModalCreateExcerciseBank v-if="isOpenModalCreateExcerciseBank" @closeModal="closeModalCreateExcerciseBank"
            @handleDone="handleDoneModalCreateExcerciseBank" />
        <ModalChooseTypePDF @closeModal="isOpenModalChooseTypePdf = false" v-if="isOpenModalChooseTypePdf"
            @handleDone="handleDoneUpload" />
        <ModalConfirmQuestionPdf :path="path" :typeUpload="typeUpload" v-if="isOpenModalConfirmQuestionPdf"
            @closeModal="handleCloseModalConfirmQuestionPdf" />

         <ModalShowHelpCreateExcercise 
         :dataItem="dataHelper"
         v-if="isOpenModalShowHelpCreateExcercise"
         @closeModal="closeModalShowHelpCreateExcercise" />   
    </div>
</template>
<script>
import ModalCreateQuestionBank from './_components/ModalCreateQuestionBank'
import ModalComfirmQuestionBank from './_components/ModalComfirmQuestionBank'
import ModalCreateExcerciseBank from './_components/ModalCreateExcerciseBank'
import { GetQuestionByDoc } from './../../_api/LessonClassSchoolServices'
import ModalChooseTypePDF from './_components/ModalChooseTypePDF'
import ModalConfirmQuestionPdf from './_components/ModalConfirmQuestionPdf'
import { downloadFileTemplateWord } from './../../_api/userExcerciseClassSchool'
import ModalShowHelpCreateExcercise from './_components/ModalShowHelpCreateExcercise'
export default {
    components: {
        ModalCreateQuestionBank,
        ModalComfirmQuestionBank,
        ModalCreateExcerciseBank,
        ModalChooseTypePDF,
        ModalConfirmQuestionPdf,
        ModalShowHelpCreateExcercise
    },
    data() {
        return {
            isOpenModalCreateExcerciseBank: false,
            isOpenModalCreateQuestionBank: false,
            isOpenModalShowConfirmQuestionbank: false,
            isOpenModalConfirmQuestionPdf: false,
            isOpenModalChooseTypePdf: false,
            listDataQuestion: [],
            file: null,
            typeUpload: 0,
            path: '',
            dataHelper:{},
            isOpenModalShowHelpCreateExcercise:false
        }
    },
    methods: {
        closeModalShowHelpCreateExcercise(){
            this.isOpenModalShowHelpCreateExcercise = false
        },  
        handleViewHelpBank(){
            this.dataHelper = {
                name:'Hướng dẫn tạo đề từ ngân hàng đề thi',
                typeId :2
            }
            this.isOpenModalShowHelpCreateExcercise =true
        },
        handleViewHelpQuestionBank(){
            this.dataHelper = {
                name:'Hướng dẫn tạo đề từ ngân hàng câu hỏi',
                typeId :2
            }
            this.isOpenModalShowHelpCreateExcercise =true
        },
        handleViewHelpWord(){
            this.dataHelper = {
                name:'Hướng dẫn tạo đề file word',
                typeId :2
            }
            this.isOpenModalShowHelpCreateExcercise =true
        },
        handleViewHelpPdf(){
            this.dataHelper = {
                name:'Hướng dẫn tạo đề file pdf',
                typeId :2
            }
            this.isOpenModalShowHelpCreateExcercise =true
        },
        downLoadTemplate() {
            downloadFileTemplateWord()
        },
        handleDoneUpload(data) {
            this.typeUpload = data.typeUpload
            this.path = data.path
            this.isOpenModalConfirmQuestionPdf = true
        },
        handleCreateExcerciseByPdf() {
            this.isOpenModalChooseTypePdf = true
        },
        handleCloseModalConfirmQuestionPdf() {
            this.isOpenModalConfirmQuestionPdf = false
        },
        handleOnUploadFileDoc() {
            this.$refs.file.click()
        },
        onChangeUploadFile() {
            let self = this
            this.file = this.$refs.file.files[0]
            const formData = new FormData();
            formData.append('file', this.file);
            this.$refs.file.value = '';
            GetQuestionByDoc(formData).then(res => {
                if (res && res.data && !res.errors) {
                    self.typeUpload = res.data.typeUpload
                    self.listDataQuestion = res.data.listExcerciseQuestionClassSchool
                    self.isOpenModalShowConfirmQuestionbank = true
                }
            })
        },
        handleDoneModalCreateExcerciseBank(listDataQuestion) {
            this.typeUpload = 1,
                this.listDataQuestion = listDataQuestion
            this.closeModalCreateQuestionBank()
            this.isOpenModalShowConfirmQuestionbank = true
        },
        closeModalCreateExcerciseBank() {
            this.isOpenModalCreateExcerciseBank = false
        },
        handleCreateExcersiceExamBank() {
            this.isOpenModalCreateExcerciseBank = true
        },
        handleDoneQuestionbank() {
            this.closeModalCreateQuestionBank()
        },
        handleDoneChooseQuestion(listDataQuestion) {
            this.typeUpload = 1,
                this.listDataQuestion = listDataQuestion
            this.closeModalCreateQuestionBank()
            this.isOpenModalShowConfirmQuestionbank = true
        },
        handleCreateExcersiceQuestionBank() {
            this.isOpenModalCreateQuestionBank = true
        },
        closeModalCreateQuestionBank() {
            this.isOpenModalCreateQuestionBank = false
        },
        closeModalConfirm() {
            this.isOpenModalShowConfirmQuestionbank = false
        },
    }
}
</script>
<style lang="scss" scoped>
.margin-top-20 {
    margin-top: 20px;
}

.menu-item {
    padding: 10px;
    border: 1px solid #0791fa;
    border-radius: 15px;
    margin: 10px;
    cursor: pointer;

    .tile-menu {
        margin-left: 10px;
        color: #0791fa;
    }
}

.item-download {
    margin: 10px;
    color: #008efa;
    cursor: pointer;
}

.item-instruct {
    margin: 10px;
    padding: 10px;
    color: #008efa;
    border: 1px solid #dfdfdf;
    border-radius: 15px;
    cursor: pointer;
}

.icon-open-book {
    width: 20px;
    height: 20px;
}
.guideline {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    align-items: center;
    width: 100%;
    left: auto;
    @media (min-width: 576px) {
        & {
            max-width: 540px;
        }
    }
    @media (min-width: 768px) {
        & {
            max-width: 720px;
        }
    }
    @media (min-width: 992px) {
        & {
            max-width: 960px;
        }
    }
    @media (min-width: 1200px) {
        & {
            max-width: 1140px;
        }
    }
    @media (min-width: 1500px) {
        & {
            max-width: 1300px;
        }
    }
}
.container {
    padding-bottom: 12rem;
}
</style>
